import React from 'react';
export const BackArrow = ({ className }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.3334 18.3332H13.0501L22.3667 9.0165L20.0001 6.6665L6.66675 19.9998L20.0001 33.3332L22.3501 30.9832L13.0501 21.6665H33.3334V18.3332Z"
        className={className}
      />
    </svg>
  );
};
export const RefreshIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.25 7.5C4.375 4.875 7 3 10 3C13.75 3 16.75 5.75 17.375 9.25H19.875C19.25 4.375 15.125 0.5 10 0.5C6.25 0.5 3 2.5 1.375 5.625L0 4.25V9.25H5L3.25 7.5ZM20 11.75H14.875L16.75 13.5C15.625 16.125 13 18 9.875 18C6.25 18 3.125 15.25 2.5 11.75H0C0.625 16.625 4.875 20.5 9.875 20.5C13.625 20.5 16.875 18.375 18.625 15.375L20 16.75V11.75Z"
        fill="#263154"
      />
    </svg>
  );
};

export const FailedIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.00004 10.3333C7.18893 10.3333 7.34737 10.2693 7.47537 10.1413C7.60293 10.0137 7.66671 9.85547 7.66671 9.66658V6.98325C7.66671 6.79436 7.60293 6.63881 7.47537 6.51658C7.34737 6.39436 7.18893 6.33325 7.00004 6.33325C6.81115 6.33325 6.65293 6.39703 6.52537 6.52458C6.39737 6.65258 6.33337 6.81103 6.33337 6.99992V9.68325C6.33337 9.87214 6.39737 10.0277 6.52537 10.1499C6.65293 10.2721 6.81115 10.3333 7.00004 10.3333ZM7.00004 4.99992C7.18893 4.99992 7.34737 4.93592 7.47537 4.80792C7.60293 4.68036 7.66671 4.52214 7.66671 4.33325C7.66671 4.14436 7.60293 3.98592 7.47537 3.85792C7.34737 3.73036 7.18893 3.66658 7.00004 3.66658C6.81115 3.66658 6.65293 3.73036 6.52537 3.85792C6.39737 3.98592 6.33337 4.14436 6.33337 4.33325C6.33337 4.52214 6.39737 4.68036 6.52537 4.80792C6.65293 4.93592 6.81115 4.99992 7.00004 4.99992ZM7.00004 13.6666C6.07782 13.6666 5.21115 13.4915 4.40004 13.1413C3.58893 12.7915 2.88337 12.3166 2.28337 11.7166C1.68337 11.1166 1.20849 10.411 0.858707 9.59992C0.508485 8.78881 0.333374 7.92214 0.333374 6.99992C0.333374 6.0777 0.508485 5.21103 0.858707 4.39992C1.20849 3.58881 1.68337 2.88325 2.28337 2.28325C2.88337 1.68325 3.58893 1.20814 4.40004 0.857919C5.21115 0.508141 6.07782 0.333252 7.00004 0.333252C7.92226 0.333252 8.78893 0.508141 9.60004 0.857919C10.4112 1.20814 11.1167 1.68325 11.7167 2.28325C12.3167 2.88325 12.7916 3.58881 13.1414 4.39992C13.4916 5.21103 13.6667 6.0777 13.6667 6.99992C13.6667 7.92214 13.4916 8.78881 13.1414 9.59992C12.7916 10.411 12.3167 11.1166 11.7167 11.7166C11.1167 12.3166 10.4112 12.7915 9.60004 13.1413C8.78893 13.4915 7.92226 13.6666 7.00004 13.6666ZM7.00004 12.3333C8.47782 12.3333 9.73626 11.8139 10.7754 10.7753C11.814 9.73614 12.3334 8.4777 12.3334 6.99992C12.3334 5.52214 11.814 4.2637 10.7754 3.22459C9.73626 2.18592 8.47782 1.66659 7.00004 1.66659C5.52226 1.66659 4.26404 2.18592 3.22537 3.22459C2.18626 4.2637 1.66671 5.52214 1.66671 6.99992C1.66671 8.4777 2.18626 9.73614 3.22537 10.7753C4.26404 11.8139 5.52226 12.3333 7.00004 12.3333Z"
        fill="#CC0000"
      />
    </svg>
  );
};

export const CompletedIcon = ({ className, onClick }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M6.5 9.18125C6.4 9.18125 6.30625 9.1655 6.21875 9.134C6.13125 9.103 6.05 9.05 5.975 8.975L3.275 6.275C3.1375 6.1375 3.06875 5.9625 3.06875 5.75C3.06875 5.5375 3.1375 5.3625 3.275 5.225C3.4125 5.0875 3.5905 5.0155 3.809 5.009C4.028 5.003 4.20625 5.06875 4.34375 5.20625L5.75 6.6125V1.25C5.75 1.0375 5.822 0.85925 5.966 0.71525C6.1095 0.57175 6.2875 0.5 6.5 0.5C6.7125 0.5 6.89075 0.57175 7.03475 0.71525C7.17825 0.85925 7.25 1.0375 7.25 1.25V6.6125L8.65625 5.20625C8.79375 5.06875 8.972 5.003 9.191 5.009C9.4095 5.0155 9.5875 5.0875 9.725 5.225C9.8625 5.3625 9.93125 5.5375 9.93125 5.75C9.93125 5.9625 9.8625 6.1375 9.725 6.275L7.025 8.975C6.95 9.05 6.86875 9.103 6.78125 9.134C6.69375 9.1655 6.6 9.18125 6.5 9.18125ZM2 12.5C1.5875 12.5 1.2345 12.3533 0.941 12.0597C0.647 11.7657 0.5 11.4125 0.5 11V9.5C0.5 9.2875 0.57175 9.10925 0.71525 8.96525C0.85925 8.82175 1.0375 8.75 1.25 8.75C1.4625 8.75 1.64075 8.82175 1.78475 8.96525C1.92825 9.10925 2 9.2875 2 9.5V11H11V9.5C11 9.2875 11.072 9.10925 11.216 8.96525C11.3595 8.82175 11.5375 8.75 11.75 8.75C11.9625 8.75 12.1405 8.82175 12.284 8.96525C12.428 9.10925 12.5 9.2875 12.5 9.5V11C12.5 11.4125 12.3533 11.7657 12.0597 12.0597C11.7657 12.3533 11.4125 12.5 11 12.5H2Z"
        fill="#263154"
      />
    </svg>
  );
};

export const WarningIcon = ({ className }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.40653 6.91516H10.422V11.9538H8.40653V6.91516ZM8.40552 12.9615H10.421V14.977H8.40552V12.9615Z"
        fill="#CC0000"
      />
      <path
        d="M11.1946 1.0702C10.8439 0.410144 10.1607 0 9.41292 0C8.66519 0 7.98195 0.410144 7.63126 1.07121L0.236583 15.0413C0.0724929 15.3481 -0.00878956 15.6923 0.00075313 16.0401C0.0102958 16.3879 0.110334 16.7272 0.291 17.0245C0.469063 17.3232 0.721943 17.5702 1.02467 17.7413C1.3274 17.9124 1.66951 18.0015 2.01723 18H16.8086C17.5221 18 18.168 17.6352 18.5358 17.0245C18.7162 16.7271 18.8161 16.3878 18.8256 16.0401C18.8352 15.6924 18.7541 15.3482 18.5903 15.0413L11.1946 1.0702ZM2.01723 15.9845L9.41292 2.01444L16.8136 15.9845H2.01723Z"
        fill="#CC0000"
      />
    </svg>
  );
};

export const AccordionUpArrow = ({ className }) => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.84487 1.07725C3.95256 0.96949 4.13204 0.96949 4.23974 1.07725L7.91923 4.79496C8.02692 4.90272 8.02692 5.08232 7.91923 5.19008L7.52436 5.5852C7.41649 5.69296 7.237 5.69296 7.12949 5.5852L4.23974 2.65772C4.13204 2.54996 3.95256 2.54996 3.84487 2.65772L0.954936 5.56724C0.847423 5.67499 0.667936 5.67499 0.560064 5.56724L0.165371 5.17212C0.0756279 5.06436 0.0756279 4.90272 0.165371 4.79496L3.84487 1.07725Z"
      className={className}
    />
  </svg>
);

export const AccordionDownArrow = ({ className }) => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.15514 4.92275C4.04744 5.03051 3.86796 5.03051 3.76026 4.92275L0.0807694 1.20504C-0.0269231 1.09728 -0.0269231 0.917683 0.0807694 0.809923L0.475642 0.414804C0.583514 0.307044 0.763001 0.307044 0.870514 0.414804L3.76026 3.34228C3.86796 3.45003 4.04744 3.45003 4.15514 3.34228L7.04506 0.432764C7.15258 0.325004 7.33206 0.325004 7.43994 0.432764L7.83463 0.827883C7.92437 0.935643 7.92437 1.09728 7.83463 1.20504L4.15514 4.92275Z"
      className={className}
    />
  </svg>
);
